import React, { Component } from 'react';
import TabSection, { SectionPlaceholder } from './TabSection';

class AtRiskTab extends Component {
    render() {
        return (
            <TabSection
                icon="far fa-exclamation-triangle"
                title="At-Risk"
                desc="Risk indicators that need attention."
            >
                <SectionPlaceholder icon="far fa-exclamation-triangle" label="At-Risk" student={this.props.student} />
            </TabSection>
        );
    }
}

export default AtRiskTab;
